module.exports = __webpack_public_path__ + "img/1-index.ed0a7dc2.svg";